import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { IAccessRequest, IAccessRequestUpdate } from 'src/types/AccesRequest';
import { HTTPValidationError, ISuccessfulResponse } from 'src/types/SiteStudyPersonal';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const accessRequestApi = createApi({
  baseQuery,
  reducerPath: 'accessRequestApi',
  endpoints: builder => ({
    getPersonnelAccessRequest: builder.query<IAccessRequest, string>({
      query: id => ({
        url: formatString(endPoints.AccessRequest.getPersonnel, { key: urlKeys.personnel_id, value: id })
      })
    }),
    updateAccessRequest: builder.mutation<ISuccessfulResponse | HTTPValidationError, IAccessRequestUpdate>({
      query: ({ site_id, study_id, data }) => ({
        url: formatString(
          endPoints.Site.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        ),
        method: 'POST',
        body: data
      })
    })
  })
});

export const { useGetPersonnelAccessRequestQuery, useUpdateAccessRequestMutation } = accessRequestApi;
